export * from './paths'
// Client hooks (useParamsGuard, useRedirectAfterLoginUrl) are deliberately not
// re-exported here: `paths` is imported by server components, and a barrel that also
// exports 'use client' modules makes every such route preload those modules' chunks.
